import axios from 'api/axiosInstance';

export interface AIReviewStatisticsItem {
  premiumRole: string;
  periodStartDate: string;
  periodEndDate: string;
  count: number;
  status?: number;
  promptType?: string;
  userId?: string;
  userName?: string;
  licenseNumber?: string;
}

export type StatisticsUnit = 'day' | 'week' | 'month' | 'all';

export interface AIReviewsStatisticsParams {
  startDate: string;
  endDate: string;
  unit: StatisticsUnit;
  simplifyPremiumRole?: boolean;
  excludeUnspecified?: boolean;
  groupByStatus?: boolean;
  groupByPromptType?: boolean;
  groupByUserId?: boolean;
}

export interface AIReviewsStatisticsResponse {
  requestedStartDate: string;
  requestedEndDate: string;
  unit: StatisticsUnit;
  statistics: AIReviewStatisticsItem[];
}

/**
 * Premium Role별 AI Review 통계 조회
 */
export async function fetchAIReviewsStatistics(
  params: AIReviewsStatisticsParams
): Promise<AIReviewsStatisticsResponse> {
  const response = await axios.get('/api/v1/admin/ai-reviews/statistics', {
    params,
  });

  if (response.data.error !== 0) {
    throw new Error(response.data.message || 'Failed to fetch statistics');
  }

  return response.data.data;
}
